<template>
  <section class="claim-page static-page">
    <div class="columns is-centered is-fullheight">
      <div class="static-page-title-container">
        <h1>
          We make the claim process<br />
          as easy as riding a bike.
        </h1>
        <h2>
          The Pedalsure Claims Promise is our guarantee to assess your claim
          within 24 hours.
        </h2>
      </div>
    </div>
    <div class="static-page-illustration">
      <img
        src="~/assets/images/illustrations/Claim-page.svg"
        alt="Homepage Trust Illustration"
      />
    </div>
    <div class="container">
      <div class="icon-container">
        <img
          src="~/assets/images/icons/blue/claim-promise.svg"
          class="icon alt"
          alt="pedalsure icon"
        />
      </div>
      <div class="sub-title has-text-centered">Our promise to you.</div>
      <p class="our-promise">
        We understand how important cycling and your bike is to you, after all
        we feel the same. Not being able to ride when you want is tough and so
        we promise to assess any claim within 24 hours.
      </p>
      <p class="our-promise">
        We’ll do whatever we can to get you out on the road as soon as we can.
        That’s the Pedalsure promise.
      </p>
      <div class="sub-title has-text-centered how-process-title">
        How the process works...
      </div>
      <div class="columns how-process">
        <div class="column">
          <img
            src="~/assets/images/icons/blue/contact.svg"
            class="icon alt"
            alt="pedalsure icon"
          />
          <span class="subtitle">Go to your dashboard</span>
          <p class="info">
            Login and visit the claims section of your dashboard
          </p>
        </div>
        <div class="column">
          <img
            src="~/assets/images/icons/blue/complete-form.svg"
            class="icon alt"
            alt="pedalsure icon"
          />
          <span class="subtitle">Complete the form</span>
          <p class="info">
            Complete the simple claim form, giving us all the details we need.
          </p>
        </div>
        <div class="column">
          <img
            src="~/assets/images/icons/blue/relax.svg"
            class="icon alt"
            alt="pedalsure icon"
          />
          <span class="subtitle">Relax</span>
          <p class="info">
            Our team will be in touch and your claim will be assessed within 24
            hours.
          </p>
        </div>
      </div>
    </div>
    <div class="container"></div>
  </section>
</template>

<script>
export default {
  name: 'Claim',
  head() {
    const title = 'Bicycle and Cyclist Insurance Claims | Pedalsure'
    const description =
      "Here you'll find all the information you need in case you have to make a bicycle and cyclist insurance claim."
    const keywords = 'bicycle insurance claim, cyclist insurance claim'
    return {
      title,
      meta: [
        { hid: 'description', name: 'description', content: description },
        { hid: 'keywords', name: 'keywords', content: keywords },
        {
          hid: 'twitter:card',
          name: 'twitter:card',
          content: 'Pedalsure - Bicycle and Cyclist Insurance Claims',
        },
        { hid: 'twitter:title', name: 'twitter:title', content: title },
        {
          hid: 'twitter:description',
          name: 'twitter:description',
          content: description,
        },
        { hid: 'og:title', property: 'og:title', content: title },
        {
          hid: 'og:description',
          property: 'og:description',
          content: description,
        },
      ],
    }
  },
  mounted() {},
  methods: {},
}
</script>

<style lang="scss" scoped>
.container {
  max-width: 1100px;
  margin: 0 auto;
  padding: 0 30px;
  .sub-title {
    font-size: 1.6rem;
    line-height: 1.8rem;
    // font-family: $family-light;
    font-family: $family-regular;
    @include desktop {
      font-size: 2rem;
      line-height: 2.1rem;
    }
  }
  .icon-container {
    text-align: center;
    margin: 20px 0;
    img {
      width: 70px;
      height: 70px;
    }
  }
  .our-promise {
    max-width: 450px;
    margin: 20px auto;
    font-family: $family-regular;
    text-align: center;
    font-size: 0.9rem;
    line-height: 1rem;
    color: $ps-gray;
    @include desktop {
      font-size: 1rem;
      line-height: 1.2rem;
    }
  }
  .how-process-title {
    margin: 70px 0 50px;
  }
  .how-process {
    text-align: center;
    margin-bottom: 40px;
    padding-bottom: 40px;
    @include desktop {
      margin-bottom: 40px;
      padding-bottom: 70px;
    }
    border-bottom: 1px solid $ps-gray;
    .subtitle {
      margin: 10px 0;
      display: block;
    }
    img {
      width: 60px;
      height: 60px;
      display: block;
      margin: 0 auto;
    }
    .info {
      line-height: 1rem;
      font-family: $family-light;
      max-width: 200px;
      margin: 0 auto;
    }
  }
}
</style>
